import axios from 'axios';
import { clearAuthData } from './auth';

const PUSH_API_URL = import.meta.env.VITE_PUSH_API_URL || 'https://push-notification.rocketgroup.io';

const pushClient = axios.create({
    baseURL: `${PUSH_API_URL}/api/v1`,
    headers: {
        'Content-Type': 'application/json',
    },
});

pushClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

pushClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearAuthData();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default pushClient;
